export default __webpack_public_path__ + "static/font-bb62132b629c81549be6e779151483ad.woff";